import About from "../Components/About/About";
import Hero from "../Components/Hero/Hero";
import Projects from "../Components/Projects/Projects";
import Service from "../Components/Service/Service";
import Skills from "../Components/Skills/Skills";
import Team from "../Components/Team/Team";
import Layout from "../Utils/Layout";
const Home = () => {
  return (
    <Layout>
      <div id="home" className="container px-sm-4 px-2 mx-auto p-0">
        <section className="mt-5">
          <Hero />
        </section>
        <section className="mt-5">
          <Service />
        </section>
        <section className="mt-5">
          <Skills />
        </section>
        <section className="mt-5">
          <Team />
        </section>
        <section className="mt-5">
          <Projects />
        </section>
        <section className="mt-5">
          <About />
        </section>
      </div>
    </Layout>
  );
};

export default Home;
